import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { computed, toRefs } from 'vue';
import { useUserStore } from '@/stores/user';
export default {
  __name: 'Content',
  setup(__props) {
    const user = useUserStore();
    const {
      headerFlag
    } = toRefs(user);
    const isInner = computed(() => {
      return window.__POWERED_BY_WUJIE__;
    });
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      const _component_el_main = _resolveComponent("el-main");
      return _openBlock(), _createBlock(_component_el_main, {
        class: _normalizeClass([_unref(isInner) ? 'app-web-content-wrapper' : 'app-content-wrapper', !_unref(headerFlag) ? 'app-header-fixed' : ''])
      }, {
        default: _withCtx(() => [_createVNode(_component_router_view)]),
        _: 1
      }, 8, ["class"]);
    };
  }
};